import React, { useState } from "react";

import "./Bar.css";

import { SketchPicker } from "react-color";

const Bar = ({ setChartConfig, bar }) => {
  const {
    horizontal,
    distributed,
    borderRadius,
    borderRadiusApplication,
    borderRadiusWhenStacked,
    labelsPosition,
    columnWidth
  } = bar;
  const [showColorPicker, setShowColorPicker] = useState(false);

  const handleBarChange = (key, value) => {
    setChartConfig((prevConfig) => {
      const clone = { ...prevConfig };

      clone.plotOptions = {
        ...clone.plotOptions,
        bar: {
          ...clone.plotOptions.bar,
          [key]: value
        }
      };

      return clone;
    });
  };

  return (
    <div className="bar-settings-container">
      {/* Title with Dropdown Icon */}
      <div className="bar-settings-header">
        <h3>Bar Settings</h3>
        <span className="bar-settings-dropdown-icon">▼</span>
      </div>

      {/* Bar Chart Settings */}
      <div>
        <div className="bar-settings-section">
          <label className="bar-settings-label">Horizontal Bars</label>
          <input
            type="checkbox"
            checked={horizontal}
            onChange={(e) => handleBarChange("horizontal", e.target.checked)}
          />
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Distributed Bars</label>
          <input
            type="checkbox"
            checked={distributed}
            onChange={(e) => handleBarChange("distributed", e.target.checked)}
          />
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Border Radius</label>
          <input
            type="number"
            value={borderRadius || 10}
            onChange={(e) => handleBarChange("borderRadius", Number(e.target.value))}
          />
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Border Radius Application</label>
          <select
            value={borderRadiusApplication}
            onChange={(e) => handleBarChange("borderRadiusApplication", e.target.value)}
          >
            <option value="around">Around</option>
            <option value="end">End</option>
          </select>
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Border Radius When Stacked</label>
          <select
            value={borderRadiusWhenStacked}
            onChange={(e) => handleBarChange("borderRadiusWhenStacked", e.target.value)}
          >
            <option value="all">All</option>
            <option value="last">Last</option>
          </select>
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Labels Position</label>
          <select
            value={labelsPosition}
            onChange={(e) =>
              handleBarChange("dataLabels", {
                ...bar?.dataLabels,
                position: e.target.value
              })
            }
          >
            <option value="top">Top</option>
            <option value="center">Center</option>
            <option value="bottom">Bottom</option>
          </select>
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Column Width</label>
          <input
            type="number"
            value={columnWidth || 30}
            onChange={(e) => handleBarChange("columnWidth", Number(e.target.value))}
          />
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Background Bar Colors</label>
          <div className="color-picker-wrapper">
            <button className="color-picker-button" onClick={() => setShowColorPicker(!showColorPicker)}>
              <div
                className="color-swatch"
                style={{
                  backgroundColor: bar?.colors?.backgroundBarColors?.[0] || "#ffffff"
                }}
              />
            </button>
            {showColorPicker && (
              <div className="picker-popover">
                <div className="picker-cover" onClick={() => setShowColorPicker(false)} />
                <SketchPicker
                  color={bar?.colors?.backgroundBarColors?.[0] || "#ffffff"}
                  onChangeComplete={(color) =>
                    handleBarChange("colors", {
                      ...bar.colors,
                      backgroundBarColors: [color.hex]
                    })
                  }
                />
              </div>
            )}
          </div>
        </div>

        <div className="bar-settings-section">
          <label className="bar-settings-label">Bar Background Opacity</label>
          <input
            type="number"
            step="0.1"
            min="0"
            max="1"
            value={bar?.colors?.backgroundBarOpacity}
            onChange={(e) =>
              handleBarChange("colors", {
                ...bar.colors,
                backgroundBarOpacity: [e.target.value]
              })
            }
          />
        </div>
      </div>
    </div>
  );
};

export default Bar;
